import { formatShortDate, formatRelativeDays } from '../../lib/relativeTime'
import type { LastShopSummary } from '../../hooks/useLastShopSummary'

type Props = {
  summary: NonNullable<LastShopSummary>
}

export function LastShopCard({ summary }: Props) {
  const dateLabel  = formatShortDate(summary.confirmedAt)
  const relLabel   = formatRelativeDays(summary.confirmedAt)
  const preview    = summary.itemNamesPreview.join(', ')
  const hasTotal   = summary.totalSpent != null && summary.totalSpent > 0
  const totalStr   = hasTotal ? `$${summary.totalSpent!.toFixed(2)}` : null

  return (
    <section className="mb-6">
      <div className="mb-[10px] flex items-baseline gap-[10px]">
        <h2 className="font-serif text-[18px] font-normal tracking-[-0.01em] text-ink">
          Last <em className="italic">shop</em>
        </h2>
        <div className="h-px flex-1 bg-border-sand" />
        <span className="text-[10px] font-medium uppercase tracking-[0.1em] text-ink-muted">
          {dateLabel} · {relLabel}
        </span>
      </div>

      <div className="rounded-[14px] border border-border-sand bg-paper p-[14px]">
        <div className="flex items-baseline gap-[6px]">
          {totalStr ? (
            <span className="font-serif text-[26px] font-normal text-ink">{totalStr}</span>
          ) : (
            <span className="font-serif text-[22px] font-normal text-ink">
              {summary.itemCount} {summary.itemCount === 1 ? 'item' : 'items'}
            </span>
          )}
          {totalStr && (
            <span className="text-[11px] italic text-ink-muted">· {summary.itemCount} items</span>
          )}
        </div>

        {summary.storeName && (
          <div className="mt-[2px] text-[11px] text-ink-muted">{summary.storeName}</div>
        )}

        {preview && (
          <>
            <div className="my-[10px] h-px bg-border-hairline" />
            <p className="truncate font-serif text-[11px] italic text-ink-muted">
              {preview}
              {summary.itemCount > summary.itemNamesPreview.length ? '…' : ''}
            </p>
          </>
        )}
      </div>
    </section>
  )
}
